/*
 * @Description: 实时定位驾驶舱 — 右侧栏（团队成员卡 + 实时动态卡）
 *   默认两卡均展开各占一半；任一收起则另一张占满；两张均收起仅留标题栏。
 */
import React, { useEffect, useState } from 'react'
import { CockpitEventItem, RealtimeMemberItem } from '../../types/cockpit.types'
import { MemberBindFilter } from '../../constants'
import TeamMembersCard from './TeamMembersCard'
import RealtimeEventsCard from './RealtimeEventsCard'
import './index.scss'

/** 图标条「成员」图标（设计稿 Frame001，20×20） */
const RailMembersIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M4.04883 6.10742C4.04883 6.6045 4.14673 7.0967 4.33696 7.55594C4.52718 8.01517 4.80599 8.43245 5.15747 8.78393C5.50896 9.13542 5.92623 9.41423 6.38547 9.60445C6.8447 9.79467 7.33691 9.89258 7.83398 9.89258C8.33106 9.89258 8.82326 9.79467 9.2825 9.60445C9.74174 9.41423 10.159 9.13542 10.5105 8.78393C10.862 8.43245 11.1408 8.01517 11.331 7.55594C11.5212 7.0967 11.6191 6.6045 11.6191 6.10742C11.6191 5.10354 11.2203 4.14077 10.5105 3.43091C9.80064 2.72106 8.83787 2.32227 7.83398 2.32227C6.8301 2.32227 5.86733 2.72106 5.15747 3.43091C4.44762 4.14077 4.04883 5.10354 4.04883 6.10742Z"
      fill="#0070F4"
    />
    <path
      d="M14.4316 16.2734C14.4316 19.5801 1.23828 19.5801 1.23828 16.2734C1.23828 12.9668 4.19141 10.9766 7.83398 10.9766C11.4766 10.9766 14.4316 12.9668 14.4316 16.2734ZM12.5918 1.24023C11.6699 1.24023 10.8262 1.57031 10.1699 2.11719C11.6406 2.83008 12.6582 4.33398 12.6582 6.08008C12.6582 7.07227 12.3262 7.98437 11.7734 8.7207C12.0371 8.7793 12.3086 8.81055 12.5898 8.81055C14.6797 8.81055 16.375 7.11523 16.375 5.02539C16.375 2.93555 14.6836 1.24023 12.5918 1.24023Z"
      fill="#0070F4"
    />
    <path
      d="M12.1602 10.0234C11.7617 10.0234 10.5371 10.1426 10.125 10.3379C12.6992 10.8613 15.498 12.8633 15.498 16.0625C15.498 16.5625 15.2949 17.0039 14.9375 17.3887C17.0879 17.0371 18.7559 16.252 18.7559 15.0332C18.7578 11.6074 15.8027 10.0234 12.1602 10.0234Z"
      fill="#0070F4"
    />
  </svg>
)

/** 图标条「动态」图标（设计稿 Frame002，29×29，自带留白故比成员图标大） */
const RailEventsIcon: React.FC = () => (
  <svg width="29" height="29" viewBox="0 0 29 29" fill="none">
    <path
      d="M8.16872 17.3692C8.16034 17.3195 8.1561 17.2692 8.15603 17.2188V11.7813C8.15603 11.7296 8.16056 11.6798 8.16872 11.6308C7.56257 11.419 7.05091 10.9995 6.72432 10.4467C6.39773 9.89386 6.27727 9.2433 6.38428 8.61018C6.49128 7.97707 6.81884 7.40222 7.30897 6.98742C7.7991 6.57262 8.42018 6.34461 9.06228 6.34375C9.70508 6.34334 10.3272 6.5707 10.8183 6.98548C11.3094 7.40026 11.6376 7.97562 11.7447 8.60943C11.8519 9.24325 11.7309 9.89451 11.4035 10.4476C11.076 11.0008 10.5631 11.42 9.95584 11.6308C9.96491 11.6798 9.96853 11.7305 9.96853 11.7813V17.2188C9.96853 17.2704 9.964 17.3203 9.95584 17.3692C10.562 17.581 11.0737 18.0005 11.4002 18.5533C11.7268 19.1061 11.8473 19.7567 11.7403 20.3898C11.6333 21.0229 11.3057 21.5978 10.8156 22.0126C10.3255 22.4274 9.70438 22.6554 9.06228 22.6563C8.41948 22.6567 7.79732 22.4293 7.30625 22.0145C6.81517 21.5997 6.48694 21.0244 6.37982 20.3906C6.2727 19.7568 6.39362 19.1055 6.72111 18.5524C7.0486 17.9992 7.56148 17.58 8.16872 17.3692ZM21.7498 9.96875H14.4998C14.2594 9.96875 14.0289 9.87327 13.859 9.70332C13.689 9.53336 13.5935 9.30285 13.5935 9.0625C13.5935 8.82215 13.689 8.59164 13.859 8.42169C14.0289 8.25173 14.2594 8.15625 14.4998 8.15625H21.7498C21.9901 8.15625 22.2206 8.25173 22.3906 8.42169C22.5606 8.59164 22.656 8.82215 22.656 9.0625C22.656 9.30285 22.5606 9.53336 22.3906 9.70332C22.2206 9.87327 21.9901 9.96875 21.7498 9.96875ZM21.7498 15.4063H16.3123C16.0719 15.4063 15.8414 15.3108 15.6715 15.1408C15.5015 14.9709 15.406 14.7404 15.406 14.5C15.406 14.2596 15.5015 14.0291 15.6715 13.8592C15.8414 13.6892 16.0719 13.5938 16.3123 13.5938H21.7498C21.9901 13.5938 22.2206 13.6892 22.3906 13.8592C22.5606 14.0291 22.656 14.2596 22.656 14.5C22.656 14.7404 22.5606 14.9709 22.3906 15.1408C22.2206 15.3108 21.9901 15.4063 21.7498 15.4063ZM21.7498 20.8438H14.4998C14.2594 20.8438 14.0289 20.7483 13.859 20.5783C13.689 20.4084 13.5935 20.1779 13.5935 19.9375C13.5935 19.6972 13.689 19.4666 13.859 19.2967C14.0289 19.1267 14.2594 19.0313 14.4998 19.0313H21.7498C21.9901 19.0313 22.2206 19.1267 22.3906 19.2967C22.5606 19.4666 22.656 19.6972 22.656 19.9375C22.656 20.1779 22.5606 20.4084 22.3906 20.5783C22.2206 20.7483 21.9901 20.8438 21.7498 20.8438ZM9.06228 19.0313C8.82193 19.0313 8.59142 19.1267 8.42146 19.2967C8.25151 19.4666 8.15603 19.6972 8.15603 19.9375C8.15603 20.1779 8.25151 20.4084 8.42146 20.5783C8.59142 20.7483 8.82193 20.8438 9.06228 20.8438C9.30263 20.8438 9.53314 20.7483 9.7031 20.5783C9.87305 20.4084 9.96853 20.1779 9.96853 19.9375C9.96853 19.6972 9.87305 19.4666 9.7031 19.2967C9.53314 19.1267 9.30263 19.0313 9.06228 19.0313ZM9.06228 8.15625C8.82193 8.15625 8.59142 8.25173 8.42146 8.42169C8.25151 8.59164 8.15603 8.82215 8.15603 9.0625C8.15603 9.30285 8.25151 9.53336 8.42146 9.70332C8.59142 9.87327 8.82193 9.96875 9.06228 9.96875C9.30263 9.96875 9.53314 9.87327 9.7031 9.70332C9.87305 9.53336 9.96853 9.30285 9.96853 9.0625C9.96853 8.82215 9.87305 8.59164 9.7031 8.42169C9.53314 8.25173 9.30263 8.15625 9.06228 8.15625Z"
      fill="#0070F4"
    />
  </svg>
)

interface RightSidebarProps {
  /** A2 成员列表（可能已按状态筛选） */
  members: RealtimeMemberItem[]
  /** 团队成员总数（标题展示） */
  total: number
  /** 当前选中成员 userId（与地图双向联动） */
  selectedUserID: string | null
  /** 绑定筛选当前值 */
  bindFilter: MemberBindFilter
  /** 绑定筛选变化 */
  onChangeBindFilter: (v: MemberBindFilter) => void
  /** 成员筛选已选人数 */
  memberFilterCount: number
  /** 点击「筛成员」 */
  onClickMemberFilter: () => void
  /** 成员列表是否还有下一页 */
  membersHasMore: boolean
  /** 成员列表上拉加载下一页 */
  onMembersLoadMore: () => void
  /** 点击成员行 */
  onSelectMember: (userId: string) => void
  /** 点击成员「轨迹 >」 */
  onClickTrack: (userId: string) => void
  /** C1 事件列表 */
  events: CockpitEventItem[]
  /** 动态卡标题（实时态「实时动态」/ 历史态「当日动态」） */
  eventsTitle: string
  /** 事件类型筛选 */
  eventTypeFilter: string
  /** 事件流是否还有下一页 */
  eventsHasMore: boolean
  /** 事件类型筛选变化 */
  onChangeEventType: (type: string) => void
  /** 事件流滑到底部加载下一页 */
  onEventsLoadMore: () => void
  /** 两张卡是否均收起变化（驱动底部时间轴延伸） */
  onBothCollapsedChange?: (collapsed: boolean) => void
}

const RightSidebar: React.FC<RightSidebarProps> = ({
  members,
  total,
  selectedUserID,
  bindFilter,
  onChangeBindFilter,
  memberFilterCount,
  onClickMemberFilter,
  membersHasMore,
  onMembersLoadMore,
  onSelectMember,
  onClickTrack,
  events,
  eventsTitle,
  eventTypeFilter,
  eventsHasMore,
  onChangeEventType,
  onEventsLoadMore,
  onBothCollapsedChange
}) => {
  const [membersCollapsed, setMembersCollapsed] = useState(false)
  const [eventsCollapsed, setEventsCollapsed] = useState(false)

  // 两张卡均收起时通知父级（底部时间轴据此向右延伸）
  useEffect(() => {
    if (onBothCollapsedChange) {
      onBothCollapsedChange(membersCollapsed && eventsCollapsed)
    }
  }, [membersCollapsed, eventsCollapsed, onBothCollapsedChange])

  // 两张卡均收起：右侧栏收成图标条（成员 / 动态），点按钮展开对应卡
  if (membersCollapsed && eventsCollapsed) {
    return (
      <div className="cockpit-right-sidebar cockpit-right-sidebar--rail">
        <div
          className="cockpit-right-sidebar__rail-tab"
          onClick={() => setMembersCollapsed(false)}
        >
          <span className="cockpit-right-sidebar__rail-icon">
            <RailMembersIcon />
          </span>
          <span className="cockpit-right-sidebar__rail-label">成员</span>
        </div>
        <div
          className="cockpit-right-sidebar__rail-tab"
          onClick={() => setEventsCollapsed(false)}
        >
          <span className="cockpit-right-sidebar__rail-icon">
            <RailEventsIcon />
          </span>
          <span className="cockpit-right-sidebar__rail-label">动态</span>
        </div>
      </div>
    )
  }

  return (
    <div className="cockpit-right-sidebar">
      <div
        className={`cockpit-right-sidebar__slot ${
          membersCollapsed ? 'is-collapsed' : ''
        }`}
      >
        <TeamMembersCard
          members={members}
          total={total}
          selectedUserID={selectedUserID}
          collapsed={membersCollapsed}
          bindFilter={bindFilter}
          onChangeBindFilter={onChangeBindFilter}
          memberFilterCount={memberFilterCount}
          onClickMemberFilter={onClickMemberFilter}
          hasMore={membersHasMore}
          onLoadMore={onMembersLoadMore}
          onSelectMember={onSelectMember}
          onClickTrack={onClickTrack}
          onToggleCollapse={() => setMembersCollapsed((v) => !v)}
        />
      </div>

      <div
        className={`cockpit-right-sidebar__slot ${
          eventsCollapsed ? 'is-collapsed' : ''
        }`}
      >
        <RealtimeEventsCard
          events={events}
          title={eventsTitle}
          typeFilter={eventTypeFilter}
          collapsed={eventsCollapsed}
          hasMore={eventsHasMore}
          onChangeType={onChangeEventType}
          onLoadMore={onEventsLoadMore}
          onToggleCollapse={() => setEventsCollapsed((v) => !v)}
        />
      </div>
    </div>
  )
}

export default RightSidebar
